export default "__VITE_ASSET__DUGSTILp__"